var map = {
	"./BIFI-logo.svg": 2059,
	"./avax-pairs/COM-AVAX.png": 2060,
	"./avax-pairs/DAI-AVAX.png": 2061,
	"./avax-pairs/ETH-AVAX.png": 2062,
	"./avax-pairs/LYD-AVAX.png": 2063,
	"./avax-pairs/OLIVE-AVAX.png": 2064,
	"./avax-pairs/OLIVE-USDT.png": 2065,
	"./avax-pairs/PNG-AVAX.png": 2066,
	"./avax-pairs/SNOB-AVAX.svg": 2067,
	"./avax-pairs/SNOB3P.png": 2068,
	"./avax-pairs/USDT-AVAX.png": 2069,
	"./avax-pairs/ZETH.svg": 2070,
	"./baby.png": 465,
	"./banners/CakeBanner.svg": 1269,
	"./binance-wallet.png": 2071,
	"./bnb-pairs/AAVE-BNB.svg": 2072,
	"./bnb-pairs/ADA-BNB.svg": 2073,
	"./bnb-pairs/ALICE-BNB.svg": 2074,
	"./bnb-pairs/ALPA-BNB.svg": 2075,
	"./bnb-pairs/ALPACA-BNB.png": 2076,
	"./bnb-pairs/ALPHA-BNB.svg": 2077,
	"./bnb-pairs/APYS-BNB.svg": 2078,
	"./bnb-pairs/ARPA-BNB.svg": 2079,
	"./bnb-pairs/ASR-BNB.svg": 2080,
	"./bnb-pairs/ATA-BNB.svg": 2081,
	"./bnb-pairs/ATM-BNB.svg": 2082,
	"./bnb-pairs/ATOM-BNB.svg": 2083,
	"./bnb-pairs/AUTO-BNB.png": 2084,
	"./bnb-pairs/AVAX-BNB.svg": 2085,
	"./bnb-pairs/BABYGROK-BNB.png": 2086,
	"./bnb-pairs/BABYGROK-USDT.png": 2087,
	"./bnb-pairs/BAKE-BNB.png": 2088,
	"./bnb-pairs/BALBT-BNB.svg": 2089,
	"./bnb-pairs/BAND-BNB.svg": 2090,
	"./bnb-pairs/BAT-BNB.svg": 2091,
	"./bnb-pairs/BCH-BNB.svg": 2092,
	"./bnb-pairs/BDO-BNB.svg": 2093,
	"./bnb-pairs/BEL-BNB.svg": 2094,
	"./bnb-pairs/BELT-BNB-BELT.png": 2095,
	"./bnb-pairs/BELT-BNB.svg": 2096,
	"./bnb-pairs/BFI-BNB.svg": 2097,
	"./bnb-pairs/BHC-BNB.png": 2098,
	"./bnb-pairs/BIFI-BNB.png": 2099,
	"./bnb-pairs/BIFI-BNB.svg": 2100,
	"./bnb-pairs/BITI-BNB.png": 2101,
	"./bnb-pairs/BLIQ-BNB.png": 2102,
	"./bnb-pairs/BLK-BNB.svg": 2103,
	"./bnb-pairs/BLZ-BNB.svg": 2104,
	"./bnb-pairs/BMXX-BNB.svg": 2105,
	"./bnb-pairs/BONDLY-BNB.svg": 2106,
	"./bnb-pairs/BOPEN-BNB.svg": 2107,
	"./bnb-pairs/BOR-BNB.svg": 2108,
	"./bnb-pairs/BRY-BNB.svg": 2109,
	"./bnb-pairs/BSCX-BNB.svg": 2110,
	"./bnb-pairs/BSHARE-BNB.png": 2111,
	"./bnb-pairs/BTC-BNB.png": 2112,
	"./bnb-pairs/BTCB-BNB.svg": 2113,
	"./bnb-pairs/BTCST-BNB.svg": 2114,
	"./bnb-pairs/BTT-BNB.svg": 2115,
	"./bnb-pairs/BUNNY-BNB.svg": 2116,
	"./bnb-pairs/BUSD-BNB.png": 2117,
	"./bnb-pairs/BUSD-BNB.svg": 2118,
	"./bnb-pairs/BUX-BNB.svg": 2119,
	"./bnb-pairs/BXBTC-BNB.svg": 2120,
	"./bnb-pairs/C98-BNB.svg": 2121,
	"./bnb-pairs/CAKE-BNB.svg": 2122,
	"./bnb-pairs/CELR-BNB.svg": 2123,
	"./bnb-pairs/CGG-BNB.svg": 2124,
	"./bnb-pairs/COM-BNB.png": 2125,
	"./bnb-pairs/COMP-BNB.svg": 2126,
	"./bnb-pairs/COS-BNB.svg": 2127,
	"./bnb-pairs/COTI-BNB.svg": 2128,
	"./bnb-pairs/CRED-BNB.png": 2129,
	"./bnb-pairs/CTK-BNB.svg": 2130,
	"./bnb-pairs/CYC-BNB.svg": 2131,
	"./bnb-pairs/DAI-BNB.svg": 2132,
	"./bnb-pairs/DEGO-BNB.svg": 2133,
	"./bnb-pairs/DEP-BNB.png": 2134,
	"./bnb-pairs/DFT-BNB.svg": 2135,
	"./bnb-pairs/DITTO-BNB.svg": 2136,
	"./bnb-pairs/DODO-BNB.svg": 2137,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 2138,
	"./bnb-pairs/DOGE-BNB.svg": 2139,
	"./bnb-pairs/DOT-BNB.svg": 2140,
	"./bnb-pairs/DRUGS-BNB.png": 2141,
	"./bnb-pairs/DUSK-BNB.svg": 2142,
	"./bnb-pairs/EASY-BNB.svg": 2143,
	"./bnb-pairs/EGLD-BNB.svg": 2144,
	"./bnb-pairs/EOS-BNB.svg": 2145,
	"./bnb-pairs/EPS-BNB.svg": 2146,
	"./bnb-pairs/ETC-BNB.svg": 2147,
	"./bnb-pairs/ETH-BNB.svg": 2148,
	"./bnb-pairs/EZ-BNB.svg": 2149,
	"./bnb-pairs/FIL-BNB.svg": 2150,
	"./bnb-pairs/FINE-BNB.svg": 2151,
	"./bnb-pairs/FRONT-BNB.svg": 2152,
	"./bnb-pairs/FTM-BNB.svg": 2153,
	"./bnb-pairs/FTS-BNB.svg": 2154,
	"./bnb-pairs/FUEL-BNB.png": 2155,
	"./bnb-pairs/GOLD-BNB.png": 2156,
	"./bnb-pairs/GROKCAT-BNB.png": 2157,
	"./bnb-pairs/GROKCAT-USDT.png": 2158,
	"./bnb-pairs/GUM-BNB.svg": 2159,
	"./bnb-pairs/GUNS-BNB.png": 2160,
	"./bnb-pairs/HARD-BNB.svg": 2161,
	"./bnb-pairs/HELMET-BNB.svg": 2162,
	"./bnb-pairs/HGET-BNB.svg": 2163,
	"./bnb-pairs/HYFI-BNB.svg": 2164,
	"./bnb-pairs/HZN-BNB.svg": 2165,
	"./bnb-pairs/INJ-BNB.svg": 2166,
	"./bnb-pairs/IOTA-BNB.svg": 2167,
	"./bnb-pairs/ITAM-BNB.svg": 2168,
	"./bnb-pairs/JBTCB-BNB.svg": 2169,
	"./bnb-pairs/JDOT-BNB.svg": 2170,
	"./bnb-pairs/JGN-BNB.png": 2171,
	"./bnb-pairs/JGN-BNB.svg": 2172,
	"./bnb-pairs/JTWT-BNB.svg": 2173,
	"./bnb-pairs/JULD-BNB.svg": 2174,
	"./bnb-pairs/JUNI-BNB.svg": 2175,
	"./bnb-pairs/JUV-BNB.svg": 2176,
	"./bnb-pairs/JXVS-BNB.svg": 2177,
	"./bnb-pairs/KALM-BNB.svg": 2178,
	"./bnb-pairs/KEBAB-BNB.png": 2179,
	"./bnb-pairs/KEYFI-BNB.svg": 2180,
	"./bnb-pairs/KTN-BNB.svg": 2181,
	"./bnb-pairs/LIEN-BNB.svg": 2182,
	"./bnb-pairs/LINK-BNB.svg": 2183,
	"./bnb-pairs/LIT-BNB.svg": 2184,
	"./bnb-pairs/LMT-BNB.svg": 2185,
	"./bnb-pairs/LTC-BNB.svg": 2186,
	"./bnb-pairs/LTO-BNB.svg": 2187,
	"./bnb-pairs/MATIC-BNB.svg": 2188,
	"./bnb-pairs/MBOX-BNB.svg": 2189,
	"./bnb-pairs/MDX-BNB.png": 2190,
	"./bnb-pairs/NAR-BNB.png": 2191,
	"./bnb-pairs/NAUT-BNB.svg": 2192,
	"./bnb-pairs/NEAR-BNB.svg": 2193,
	"./bnb-pairs/NRV-BNB.svg": 2194,
	"./bnb-pairs/ODDZ-BNB.svg": 2195,
	"./bnb-pairs/OG-BNB.svg": 2196,
	"./bnb-pairs/ONT-BNB.svg": 2197,
	"./bnb-pairs/PBTC-BNB.svg": 2198,
	"./bnb-pairs/PERL-BNB.svg": 2199,
	"./bnb-pairs/POPEN-BNB.svg": 2200,
	"./bnb-pairs/PSG-BNB.svg": 2201,
	"./bnb-pairs/REEF-BNB.svg": 2202,
	"./bnb-pairs/SFP-BNB.svg": 2203,
	"./bnb-pairs/SHIB-BNB.svg": 2204,
	"./bnb-pairs/SNX-BNB.svg": 2205,
	"./bnb-pairs/SOAK-BNB.svg": 2206,
	"./bnb-pairs/SPG-BNB.svg": 2207,
	"./bnb-pairs/STEAM-BNB.svg": 2208,
	"./bnb-pairs/SUTER-BNB.svg": 2209,
	"./bnb-pairs/SWAMP-BNB.svg": 2210,
	"./bnb-pairs/SWGB-BNB.svg": 2211,
	"./bnb-pairs/SWINGBY-BNB.svg": 2212,
	"./bnb-pairs/SWIRL-BNB.png": 2213,
	"./bnb-pairs/SWTH-BNB.svg": 2214,
	"./bnb-pairs/SXP-BNB.svg": 2215,
	"./bnb-pairs/TDOGE-BNB.svg": 2216,
	"./bnb-pairs/TEN-BNB.svg": 2217,
	"./bnb-pairs/THUGS-BNB.png": 2218,
	"./bnb-pairs/TKO-BNB.svg": 2219,
	"./bnb-pairs/TLM-BNB.svg": 2220,
	"./bnb-pairs/TRADE-BNB.svg": 2221,
	"./bnb-pairs/TRX-BNB.svg": 2222,
	"./bnb-pairs/TWT-BNB.svg": 2223,
	"./bnb-pairs/TYPH-BNB.png": 2224,
	"./bnb-pairs/UNFI-BNB.svg": 2225,
	"./bnb-pairs/UNI-BNB.svg": 2226,
	"./bnb-pairs/USDC-BNB.svg": 2227,
	"./bnb-pairs/USDT-BNB.svg": 2228,
	"./bnb-pairs/VAPOR-BNB.png": 2229,
	"./bnb-pairs/VIDT-BNB.svg": 2230,
	"./bnb-pairs/VRT-BNB.svg": 2231,
	"./bnb-pairs/WATCH-BNB-APE.svg": 2232,
	"./bnb-pairs/WATCH-BNB.svg": 2233,
	"./bnb-pairs/WEX-BNB.png": 2234,
	"./bnb-pairs/WIN-BNB.svg": 2235,
	"./bnb-pairs/WSOTE-BNB.svg": 2236,
	"./bnb-pairs/XED-BNB.svg": 2237,
	"./bnb-pairs/XEND-BNB.svg": 2238,
	"./bnb-pairs/XRP-BNB.svg": 2239,
	"./bnb-pairs/XTZ-BNB.svg": 2240,
	"./bnb-pairs/XVS-BNB.svg": 2241,
	"./bnb-pairs/YFI-BNB.svg": 2242,
	"./bnb-pairs/YFII-BNB.svg": 2243,
	"./bnb-pairs/ZEC-BNB.svg": 2244,
	"./bnb-pairs/ZEE-BNB.svg": 2245,
	"./bnb-pairs/ZIL-BNB.svg": 2246,
	"./bnb-pairs/bROOBEE-BNB.svg": 2247,
	"./bnb-pairs/bTRI-BNB.png": 2248,
	"./bnb-pairs/pCWS-BNB.svg": 2249,
	"./bnb-pairs/typh-bnb.svg": 2250,
	"./busd-pairs/ADA-BUSD.png": 2251,
	"./busd-pairs/ALPACA-BUSD.svg": 2252,
	"./busd-pairs/BAKE-BUSD.png": 2253,
	"./busd-pairs/BCFX-BUSD.svg": 2254,
	"./busd-pairs/BIFI-BUSD.png": 2255,
	"./busd-pairs/BTCB-BUSD.svg": 2256,
	"./busd-pairs/BTR-BUSD.svg": 2257,
	"./busd-pairs/BUSD-USDC.svg": 2258,
	"./busd-pairs/DAI-BUSD.png": 2259,
	"./busd-pairs/DAI-BUSD.svg": 2260,
	"./busd-pairs/DEXE-BUSD.svg": 2261,
	"./busd-pairs/DFD-BUSD.svg": 2262,
	"./busd-pairs/FOR-BUSD.svg": 2263,
	"./busd-pairs/HAKKA-BUSD.svg": 2264,
	"./busd-pairs/HOO-BUSD.svg": 2265,
	"./busd-pairs/IOTX-BUSD.svg": 2266,
	"./busd-pairs/KEBAB-BUSD.png": 2267,
	"./busd-pairs/KUN-BUSD.svg": 2268,
	"./busd-pairs/LINA-BUSD.svg": 2269,
	"./busd-pairs/LTC-BUSD.png": 2270,
	"./busd-pairs/MATH-BUSD.svg": 2271,
	"./busd-pairs/MDX-BUSD.png": 2272,
	"./busd-pairs/MTRG-BUSD.svg": 2273,
	"./busd-pairs/MX-BUSD.svg": 2274,
	"./busd-pairs/NULS-BUSD.svg": 2275,
	"./busd-pairs/OIN-BUSD.svg": 2276,
	"./busd-pairs/ONE-BUSD.svg": 2277,
	"./busd-pairs/PMON-BUSD.svg": 2278,
	"./busd-pairs/QKC-BUSD.svg": 2279,
	"./busd-pairs/RAMP-BUSD.svg": 2280,
	"./busd-pairs/SWAMP-BUSD.svg": 2281,
	"./busd-pairs/TPT-BUSD.svg": 2282,
	"./busd-pairs/TUSD-BUSD.svg": 2283,
	"./busd-pairs/TXL-BUSD.svg": 2284,
	"./busd-pairs/UBXT-BUSD.svg": 2285,
	"./busd-pairs/USDC-BUSD.svg": 2286,
	"./busd-pairs/USDT-BUSD.png": 2287,
	"./busd-pairs/USDT-BUSD.svg": 2288,
	"./busd-pairs/UST-BUSD.svg": 2289,
	"./busd-pairs/VAI-BUSD.svg": 2290,
	"./busd-pairs/WELL-BUSD.svg": 2291,
	"./busd-pairs/WMASS-BUSD.svg": 2292,
	"./busd-pairs/XMARK-BUSD.svg": 2293,
	"./busd-pairs/XRP-BUSD.png": 2294,
	"./cake-pairs/BROOBEE-CAKE.svg": 2295,
	"./cake-pairs/CAKE-BUSD.svg": 2296,
	"./cake-pairs/NAR-CAKE.svg": 2297,
	"./cake-pairs/NYA-CAKE.svg": 2298,
	"./cake-pairs/STAX-CAKE.svg": 2299,
	"./cake-pairs/ampl-bsc-mp-busd.svg": 2300,
	"./cake-pairs/btcb-eth.svg": 2301,
	"./cake-pairs/chr-busd.svg": 2302,
	"./cake-pairs/deri-busd.svg": 2303,
	"./cake-pairs/eth-usdc.svg": 2304,
	"./cake-pairs/hotcross-bnb.svg": 2305,
	"./cake-pairs/rfox-bnb.svg": 2306,
	"./crow/crow.png": 2307,
	"./degens/ADA-BNB.svg": 2308,
	"./degens/BANANA-DOT-BNB.svg": 2309,
	"./degens/BANANA-EPS-BNB.svg": 2310,
	"./degens/BANANA-GUARD-BNB.svg": 2311,
	"./degens/BANANA-SFP-BNB.svg": 2312,
	"./degens/BANANA-SUSHI-BNB.svg": 2313,
	"./degens/BANANA-TWT-BNB.svg": 2314,
	"./degens/BANANA-XRP-BNB.svg": 2315,
	"./degens/BANANA-XVS-BNB.svg": 2316,
	"./degens/BANANA.svg": 2317,
	"./degens/BGO.png": 2318,
	"./degens/BIFI-BNB-banana.svg": 2319,
	"./degens/BIFI-BNB.svg": 2320,
	"./degens/BITI.png": 2321,
	"./degens/BLZD-BNB.png": 2322,
	"./degens/BLZD-BUSD.png": 2323,
	"./degens/BLZD.png": 2324,
	"./degens/DND.png": 2325,
	"./degens/FTS-BNB.svg": 2326,
	"./degens/FUEL-BNB.svg": 2327,
	"./degens/GOAL-BUSD.png": 2328,
	"./degens/IRON.png": 2329,
	"./degens/LINK-BNB.svg": 2330,
	"./degens/NAUT.png": 2331,
	"./degens/PALM.png": 2332,
	"./degens/SAT-BNB.png": 2333,
	"./degens/SAT-BUSD.png": 2334,
	"./degens/SBGO.png": 2335,
	"./degens/SOUP-BNB.svg": 2336,
	"./degens/SOUPS-BNB.svg": 2337,
	"./degens/SPACE-BNB.png": 2338,
	"./degens/SPACE-BUSD.png": 2339,
	"./degens/STEEL.png": 2340,
	"./degens/WINGS-BNB-BUSD.svg": 2341,
	"./degens/WINGS-BNB.svg": 2342,
	"./degens/WINGS-BUSD.svg": 2343,
	"./degens/WINGS-USDC-BUSD.svg": 2344,
	"./degens/WINGS.svg": 2345,
	"./degens/ZEFI-BNB.svg": 2346,
	"./degens/ZEFI-BUSD.svg": 2347,
	"./degens/ape-bnb.png": 2348,
	"./degens/banana-bnb.svg": 2349,
	"./degens/banana-busd.svg": 2350,
	"./degens/banana-ltc-bnb.svg": 2351,
	"./degens/brew-bnb.svg": 2352,
	"./degens/brew-busd.svg": 2353,
	"./degens/garuda-bnb.png": 2354,
	"./degens/garuda-usdc.png": 2355,
	"./degens/garuda-usdt.png": 2356,
	"./degens/grand-bnb.png": 2357,
	"./degens/grand.png": 2358,
	"./degens/mash-bnb.png": 2359,
	"./degens/mash-busd.png": 2360,
	"./degens/mash.png": 2361,
	"./degens/mfrm-bnb.png": 2362,
	"./degens/palm-bnb.png": 2363,
	"./degens/palm-busd.png": 2364,
	"./degens/panther-bnb.png": 2365,
	"./degens/panther-busd.png": 2366,
	"./degens/quant-busd.png": 2367,
	"./degens/ramen-bnb.svg": 2368,
	"./degens/ramen-busd.svg": 2369,
	"./degens/salt-bnb.png": 2370,
	"./degens/salt-busd.png": 2371,
	"./degens/sdump-bnb.png": 2372,
	"./degens/sdump-busd.png": 2373,
	"./degens/slime-bnb.png": 2374,
	"./degens/slime-busd.png": 2375,
	"./degens/tndr-bnb.png": 2376,
	"./degens/tndr-busd.png": 2377,
	"./degens/tofy-bnb.png": 2378,
	"./degens/tofy-mash.png": 2379,
	"./degens/tofy.png": 2380,
	"./eth-pairs/ADA-ETH.svg": 2381,
	"./eth-pairs/BETH-ETH.svg": 2382,
	"./eth-pairs/BTCB-ETH.svg": 2383,
	"./eth-pairs/ETH-BNB.png": 2384,
	"./eth-pairs/ETH-BTC.png": 2385,
	"./fantom/Battle Bands.png": 2386,
	"./fantom/Beardhemian Brushsody.png": 2387,
	"./fantom/Clair de Lune.png": 2388,
	"./fantom/Dance of The Degens.png": 2389,
	"./fantom/Dante Symphony.png": 2390,
	"./fantom/FROYO-3Pool.png": 2391,
	"./fantom/Fantom Conservatory.png": 2392,
	"./fantom/Fantom Sonata.png": 2393,
	"./fantom/Guqin Qi 2.png": 2394,
	"./fantom/Guqin Qi.png": 2395,
	"./fantom/Late Quartet.png": 2396,
	"./fantom/Multichain Maxi.png": 2397,
	"./fantom/Paint It Black.png": 2398,
	"./fantom/Song Of Ice And Fire.png": 2399,
	"./fantom/Sound of Moosic.png": 2400,
	"./fantom/TOMB-FTM.png": 2401,
	"./fantom/TOR-2CRV.svg": 2402,
	"./fantom/TSHARE-FTM.png": 2403,
	"./fantom/The Classic Trio.png": 2404,
	"./fantom/The Grand Orchestra.png": 2405,
	"./fantom/The Magic Touch By Daniele.png": 2406,
	"./fantom/The Spooky-Tempered Clavier.png": 2407,
	"./fantom/Tubular Bells.png": 2408,
	"./fantom/Variation Theme USDC.png": 2409,
	"./fantom/WAGMI Index.png": 2410,
	"./fantom/When Two Became One.png": 2411,
	"./fantom/Ziggy Stardust & Magic Internet Money.png": 2412,
	"./fantom/baron-von-binance.png": 2413,
	"./fantom/double-dollar-fugue.png": 2414,
	"./fantom/solana-sonata.png": 2415,
	"./heco/AAVE-USDT.svg": 2416,
	"./heco/BAL-USDT.svg": 2417,
	"./heco/ETH-USDT.png": 2418,
	"./heco/ETH-WHT.svg": 2419,
	"./heco/HBCH-USDT.svg": 2420,
	"./heco/HBTC-USDT.png": 2421,
	"./heco/HBTC-WHT.svg": 2422,
	"./heco/HDOT-USDT.svg": 2423,
	"./heco/HFI-HT.png": 2424,
	"./heco/HFI-HUSD.png": 2425,
	"./heco/HFIL-USDT.svg": 2426,
	"./heco/HLTC-USDT.svg": 2427,
	"./heco/HPT-USDT.svg": 2428,
	"./heco/HUSD-USDT.svg": 2429,
	"./heco/HUSD.png": 2430,
	"./heco/LAVA-HT.svg": 2431,
	"./heco/LAVA-USDT.svg": 2432,
	"./heco/LAVA.png": 2433,
	"./heco/LHB-USDT.svg": 2434,
	"./heco/LHB-WHT.png": 2435,
	"./heco/LINK-USDT.svg": 2436,
	"./heco/MDX-USDT.png": 2437,
	"./heco/MDX-WHT.png": 2438,
	"./heco/SNX-USDT.svg": 2439,
	"./heco/UNI-USDT.svg": 2440,
	"./heco/WHT-HUSD.png": 2441,
	"./heco/WHT-USDT.png": 2442,
	"./heco/YFI-USDT.svg": 2443,
	"./heco/fHT.png": 2444,
	"./heco/fUNI.png": 2445,
	"./kebab/ETH-BTCB.png": 2446,
	"./kebab/KEBAB-BTCB.png": 2447,
	"./kebab/USDT-BUSD.png": 2448,
	"./polygon/AAVE-ETH.png": 2449,
	"./polygon/ADDY.png": 2450,
	"./polygon/ANY-QUICK.png": 2451,
	"./polygon/AZUKI-ETH.png": 2452,
	"./polygon/BIFI-ETH.png": 2453,
	"./polygon/BIFI-MATIC.png": 2454,
	"./polygon/BIFI-MUST.png": 2455,
	"./polygon/BIFI-QUICK.png": 2456,
	"./polygon/BTC-USDC.png": 2457,
	"./polygon/CC10-ETH.png": 2458,
	"./polygon/CC10-QUICK.png": 2459,
	"./polygon/CEL-ETH.png": 2460,
	"./polygon/CRV-ETH.png": 2461,
	"./polygon/CURVE-3Pool.png": 2462,
	"./polygon/DEFI5-ETH.png": 2463,
	"./polygon/DEFI5-QUICK.png": 2464,
	"./polygon/DEGEN-ETH.png": 2465,
	"./polygon/DEGEN-QUICK.png": 2466,
	"./polygon/DOKI-ETH.png": 2467,
	"./polygon/ETH-BTC.png": 2468,
	"./polygon/ETH-DAI.png": 2469,
	"./polygon/ETH-FIL.png": 2470,
	"./polygon/ETH-MATIC.png": 2471,
	"./polygon/ETH-USDT.png": 2472,
	"./polygon/FFF-QUICK.png": 2473,
	"./polygon/FISH-MATIC.svg": 2474,
	"./polygon/FRAX-FXS.png": 2475,
	"./polygon/FRAX-QUICK.png": 2476,
	"./polygon/FRAX-USDC.png": 2477,
	"./polygon/GRT-ETH.png": 2478,
	"./polygon/IRON-ETH.png": 2479,
	"./polygon/IRON-USDC.png": 2480,
	"./polygon/IRON.png": 2481,
	"./polygon/KRILL-USDC.png": 2482,
	"./polygon/LINK-ETH.png": 2483,
	"./polygon/LINK-QUICK.png": 2484,
	"./polygon/MATIC-USDC.png": 2485,
	"./polygon/MATIC-WOOFY.png": 2486,
	"./polygon/MIMATIC-USDC.png": 2487,
	"./polygon/MUST-ETH.png": 2488,
	"./polygon/MUST-MATIC.png": 2489,
	"./polygon/PZAP-MATIC.png": 2490,
	"./polygon/PZAP-USDC.png": 2491,
	"./polygon/QUICK-ETH.png": 2492,
	"./polygon/QUICK-MATIC.png": 2493,
	"./polygon/QUICK-UNI.png": 2494,
	"./polygon/SNX-ETH.png": 2495,
	"./polygon/TITAN-ETH.png": 2496,
	"./polygon/TITAN-IRON.png": 2497,
	"./polygon/TITAN-MATIC.png": 2498,
	"./polygon/TITAN.png": 2499,
	"./polygon/UBT-ETH.png": 2500,
	"./polygon/USDC-DAI.png": 2501,
	"./polygon/USDC-ETH.png": 2502,
	"./polygon/USDC-MUST.png": 2503,
	"./polygon/USDC-USDT.png": 2504,
	"./polygon/VISION-ETH.png": 2505,
	"./polygon/VISION-QUICK.png": 2506,
	"./polygon/WEX-MATIC.png": 2507,
	"./polygon/WEX-USDC.png": 2508,
	"./polygon/WEX.png": 2509,
	"./polygon/WEXPOLY-BTC.png": 2510,
	"./polygon/WISE-ETH.png": 2511,
	"./polygon/mOCEAN-MATIC.png": 2512,
	"./polygon/maUSDC-USDC.png": 2513,
	"./polygon/renDOGE-ETH.png": 2514,
	"./single-assets/2CAD.svg": 720,
	"./single-assets/2JPY.svg": 721,
	"./single-assets/2NZD.svg": 722,
	"./single-assets/2OMB.png": 723,
	"./single-assets/2SGD.png": 724,
	"./single-assets/2SHARES.png": 725,
	"./single-assets/4EUR.png": 726,
	"./single-assets/AAVE.svg": 727,
	"./single-assets/AAVEe.svg": 728,
	"./single-assets/ACRE.png": 729,
	"./single-assets/ADA.svg": 730,
	"./single-assets/ADX.svg": 731,
	"./single-assets/ALI.svg": 732,
	"./single-assets/ALPACA.png": 733,
	"./single-assets/ALPHA.png": 734,
	"./single-assets/AMPL.png": 735,
	"./single-assets/ANN.png": 736,
	"./single-assets/ANY.png": 737,
	"./single-assets/AOT.png": 738,
	"./single-assets/APE.png": 739,
	"./single-assets/ARBITRUM.svg": 740,
	"./single-assets/ATLAS.png": 741,
	"./single-assets/ATOM.png": 742,
	"./single-assets/AURO.png": 743,
	"./single-assets/AURORA.svg": 744,
	"./single-assets/AVALANCHE.svg": 745,
	"./single-assets/AVAX.png": 746,
	"./single-assets/AVAX.svg": 747,
	"./single-assets/AVAXL.svg": 748,
	"./single-assets/AXS.png": 749,
	"./single-assets/Andromeda.svg": 750,
	"./single-assets/BABY.svg": 751,
	"./single-assets/BABYCAKE.svg": 752,
	"./single-assets/BAKE.png": 753,
	"./single-assets/BALL.png": 754,
	"./single-assets/BANANA.svg": 755,
	"./single-assets/BASED.svg": 756,
	"./single-assets/BCH.svg": 757,
	"./single-assets/BCT.png": 758,
	"./single-assets/BDO.png": 759,
	"./single-assets/BDP.png": 760,
	"./single-assets/BEAR.png": 761,
	"./single-assets/BEETS.png": 762,
	"./single-assets/BETA.svg": 763,
	"./single-assets/BETH.png": 764,
	"./single-assets/BETU.png": 765,
	"./single-assets/BHC.png": 766,
	"./single-assets/BICO.png": 767,
	"./single-assets/BIFI.png": 768,
	"./single-assets/BISON.png": 769,
	"./single-assets/BLZZ.svg": 770,
	"./single-assets/BMON.svg": 771,
	"./single-assets/BNB.png": 772,
	"./single-assets/BNBbsc.png": 773,
	"./single-assets/BOMB.png": 774,
	"./single-assets/BONE.png": 775,
	"./single-assets/BONEswap.png": 776,
	"./single-assets/BOO.png": 777,
	"./single-assets/BOOK.png": 778,
	"./single-assets/BORING.png": 779,
	"./single-assets/BP.png": 780,
	"./single-assets/BPT.png": 781,
	"./single-assets/BREW.png": 782,
	"./single-assets/BRIBE.png": 783,
	"./single-assets/BRUSH.png": 784,
	"./single-assets/BSC.svg": 785,
	"./single-assets/BSCDEFI.svg": 786,
	"./single-assets/BSCPAD.png": 787,
	"./single-assets/BSHARE.svg": 788,
	"./single-assets/BSTN.svg": 789,
	"./single-assets/BSW.svg": 790,
	"./single-assets/BTC.svg": 791,
	"./single-assets/BTCB.svg": 792,
	"./single-assets/BTD.png": 793,
	"./single-assets/BTS.png": 794,
	"./single-assets/BTT.png": 795,
	"./single-assets/BUNNY.png": 796,
	"./single-assets/BURGER.png": 797,
	"./single-assets/BUSD.svg": 798,
	"./single-assets/BUSDe.svg": 799,
	"./single-assets/BUSM.png": 800,
	"./single-assets/BYTE.png": 801,
	"./single-assets/CAKE.svg": 802,
	"./single-assets/CAPS.svg": 803,
	"./single-assets/CARROT.png": 804,
	"./single-assets/CCAR.png": 805,
	"./single-assets/CEEK.png": 806,
	"./single-assets/CEL.png": 807,
	"./single-assets/CELO.svg": 808,
	"./single-assets/CHARGE.png": 809,
	"./single-assets/CHARM.svg": 810,
	"./single-assets/CHESS.svg": 811,
	"./single-assets/CLAM.png": 812,
	"./single-assets/CLY.png": 813,
	"./single-assets/COOK.png": 814,
	"./single-assets/CRA.png": 815,
	"./single-assets/CRAFT.png": 816,
	"./single-assets/CRE8R.png": 817,
	"./single-assets/CREAM.svg": 818,
	"./single-assets/CRO.svg": 819,
	"./single-assets/CRONA.svg": 820,
	"./single-assets/CRONOS.svg": 821,
	"./single-assets/CRUSH.svg": 822,
	"./single-assets/CRV.png": 823,
	"./single-assets/CRYSTL.png": 824,
	"./single-assets/CTK.png": 825,
	"./single-assets/CYT.png": 826,
	"./single-assets/CZF.png": 827,
	"./single-assets/DAI.png": 828,
	"./single-assets/DAI.svg": 829,
	"./single-assets/DAIe.png": 830,
	"./single-assets/DAR.svg": 831,
	"./single-assets/DARK.svg": 832,
	"./single-assets/DBY.png": 833,
	"./single-assets/DCAU.png": 834,
	"./single-assets/DEG.png": 835,
	"./single-assets/DEI.png": 836,
	"./single-assets/DELIRIUM.png": 837,
	"./single-assets/DEP.png": 838,
	"./single-assets/DEUS.png": 839,
	"./single-assets/DFYN.png": 840,
	"./single-assets/DG.png": 841,
	"./single-assets/DIBS.png": 842,
	"./single-assets/DINO.png": 843,
	"./single-assets/DIS.svg": 844,
	"./single-assets/DKT.png": 845,
	"./single-assets/DOGE.svg": 846,
	"./single-assets/DOLA.png": 847,
	"./single-assets/DOMI.png": 848,
	"./single-assets/DOT.png": 849,
	"./single-assets/DPI.png": 850,
	"./single-assets/DPT.png": 851,
	"./single-assets/DRUGS.png": 852,
	"./single-assets/DSHARE.png": 853,
	"./single-assets/DUET.svg": 854,
	"./single-assets/DVI.svg": 855,
	"./single-assets/ECD.png": 856,
	"./single-assets/EGG.png": 857,
	"./single-assets/ELK.png": 858,
	"./single-assets/ELON.png": 859,
	"./single-assets/EMERALD.png": 860,
	"./single-assets/EMP.png": 861,
	"./single-assets/EPS.png": 862,
	"./single-assets/ERA.svg": 863,
	"./single-assets/ERTHA.png": 864,
	"./single-assets/ESHARE.png": 865,
	"./single-assets/EST.png": 866,
	"./single-assets/ETERNAL.png": 867,
	"./single-assets/ETH.svg": 868,
	"./single-assets/ETH2x.png": 869,
	"./single-assets/ETHs.svg": 870,
	"./single-assets/EURt.png": 871,
	"./single-assets/EXP.svg": 872,
	"./single-assets/EZ.png": 873,
	"./single-assets/FANTOM.svg": 874,
	"./single-assets/FET.png": 875,
	"./single-assets/FFF.png": 876,
	"./single-assets/FIEF.png": 877,
	"./single-assets/FIL.svg": 878,
	"./single-assets/FINN.png": 879,
	"./single-assets/FIRE.png": 880,
	"./single-assets/FISH.svg": 881,
	"./single-assets/FITFI.png": 882,
	"./single-assets/FLARE.png": 883,
	"./single-assets/FLX.png": 884,
	"./single-assets/FLY.png": 885,
	"./single-assets/FODL.png": 886,
	"./single-assets/FONT.png": 887,
	"./single-assets/FOO.png": 888,
	"./single-assets/FORM.svg": 889,
	"./single-assets/FOX.png": 890,
	"./single-assets/FRAX.svg": 891,
	"./single-assets/FRM.png": 892,
	"./single-assets/FROYO.png": 893,
	"./single-assets/FRUIT.png": 894,
	"./single-assets/FS.png": 895,
	"./single-assets/FTM.png": 896,
	"./single-assets/FTML.svg": 897,
	"./single-assets/FUSE Network.svg": 898,
	"./single-assets/FUSE.svg": 899,
	"./single-assets/FXS.png": 900,
	"./single-assets/G.png": 901,
	"./single-assets/GAL.png": 902,
	"./single-assets/GEIST.svg": 903,
	"./single-assets/GEL.png": 904,
	"./single-assets/GENESIS.png": 905,
	"./single-assets/GHST.png": 906,
	"./single-assets/GLINT.png": 907,
	"./single-assets/GLMR.png": 908,
	"./single-assets/GM.png": 909,
	"./single-assets/GMT.svg": 910,
	"./single-assets/GMX.png": 911,
	"./single-assets/GNS.png": 912,
	"./single-assets/GNT.png": 913,
	"./single-assets/GOLDCOIN.svg": 914,
	"./single-assets/GRAPE.png": 915,
	"./single-assets/GUARD.svg": 916,
	"./single-assets/HAI.png": 917,
	"./single-assets/HARD.png": 918,
	"./single-assets/HARMONY.svg": 919,
	"./single-assets/HBAR.png": 920,
	"./single-assets/HBTC.png": 921,
	"./single-assets/HEC.png": 922,
	"./single-assets/HECO.svg": 923,
	"./single-assets/HERO.png": 924,
	"./single-assets/HIGH.png": 925,
	"./single-assets/HND.png": 926,
	"./single-assets/HONEY.png": 927,
	"./single-assets/HONOR.png": 928,
	"./single-assets/HOTCROSS.svg": 929,
	"./single-assets/HPS.png": 930,
	"./single-assets/HT.png": 931,
	"./single-assets/HTB.svg": 932,
	"./single-assets/HUSD.png": 933,
	"./single-assets/ICA.svg": 934,
	"./single-assets/ICE.png": 935,
	"./single-assets/IDIA.svg": 936,
	"./single-assets/IF.svg": 937,
	"./single-assets/IME.png": 938,
	"./single-assets/INCH.png": 939,
	"./single-assets/INJ.png": 940,
	"./single-assets/INSUR.png": 941,
	"./single-assets/INV.png": 942,
	"./single-assets/IRON.png": 943,
	"./single-assets/IXT.png": 944,
	"./single-assets/JETS.png": 945,
	"./single-assets/JEWEL.png": 946,
	"./single-assets/JOE.png": 947,
	"./single-assets/JPYC.png": 948,
	"./single-assets/JRT.png": 949,
	"./single-assets/JULD.png": 950,
	"./single-assets/JUST.png": 951,
	"./single-assets/KAE.png": 952,
	"./single-assets/KART.png": 953,
	"./single-assets/KEBAB.png": 954,
	"./single-assets/KEK.png": 955,
	"./single-assets/KIRO.png": 956,
	"./single-assets/KLIMA.png": 957,
	"./single-assets/KLO.png": 958,
	"./single-assets/KRW.png": 959,
	"./single-assets/LAC.svg": 960,
	"./single-assets/LAMBDA.svg": 961,
	"./single-assets/LAND.svg": 962,
	"./single-assets/LAZIO.png": 963,
	"./single-assets/LINEAR.svg": 964,
	"./single-assets/LINK.png": 965,
	"./single-assets/LINKe.png": 966,
	"./single-assets/LIQ.png": 967,
	"./single-assets/LITHIUM.svg": 968,
	"./single-assets/LONG.png": 969,
	"./single-assets/LOOT.png": 970,
	"./single-assets/LOST.png": 971,
	"./single-assets/LTC.svg": 972,
	"./single-assets/LUNA.png": 973,
	"./single-assets/MAGIC.png": 974,
	"./single-assets/MAI.png": 975,
	"./single-assets/MAI_Rose.png": 976,
	"./single-assets/MANA.png": 977,
	"./single-assets/MARSH.png": 978,
	"./single-assets/MASK.svg": 979,
	"./single-assets/MATIC.svg": 980,
	"./single-assets/MCB.png": 981,
	"./single-assets/MCRN.svg": 982,
	"./single-assets/MDX.png": 983,
	"./single-assets/MEAD.png": 984,
	"./single-assets/MECHA.png": 985,
	"./single-assets/MELT.png": 986,
	"./single-assets/MERL.svg": 987,
	"./single-assets/METAHERO.svg": 988,
	"./single-assets/METIS.svg": 989,
	"./single-assets/MIDAS.png": 990,
	"./single-assets/MILK.png": 991,
	"./single-assets/MIM.png": 992,
	"./single-assets/MOBI.svg": 993,
	"./single-assets/MONEY.png": 994,
	"./single-assets/MOON.png": 995,
	"./single-assets/MOONBEAM.svg": 996,
	"./single-assets/MOONRIVER.svg": 997,
	"./single-assets/MORE.png": 998,
	"./single-assets/MOVR.png": 999,
	"./single-assets/MSC.png": 1000,
	"./single-assets/MSS.png": 1001,
	"./single-assets/MST.png": 1002,
	"./single-assets/MULTI.png": 1003,
	"./single-assets/MUST.png": 1004,
	"./single-assets/MaticX.svg": 1005,
	"./single-assets/NABOX.png": 1006,
	"./single-assets/NAOS.png": 1007,
	"./single-assets/NCASH.png": 1008,
	"./single-assets/NEAR.svg": 1009,
	"./single-assets/NETT.png": 1010,
	"./single-assets/NEXO.png": 1011,
	"./single-assets/NFT.png": 1012,
	"./single-assets/NFTY.png": 1013,
	"./single-assets/NUGGET.svg": 1014,
	"./single-assets/NUTS.png": 1015,
	"./single-assets/NYA.png": 1016,
	"./single-assets/NYAC.png": 1017,
	"./single-assets/NYAS.png": 1018,
	"./single-assets/NZDS.png": 1019,
	"./single-assets/O3.png": 1020,
	"./single-assets/OASIS.svg": 1021,
	"./single-assets/OCP.png": 1022,
	"./single-assets/ONE.svg": 1023,
	"./single-assets/ONG.svg": 1024,
	"./single-assets/ONT.png": 1025,
	"./single-assets/OOE.svg": 1026,
	"./single-assets/ORBS.svg": 1027,
	"./single-assets/ORKAN.png": 1028,
	"./single-assets/OXD.png": 1029,
	"./single-assets/PACOCA.svg": 1030,
	"./single-assets/PAE.svg": 1031,
	"./single-assets/PAE_AVAX.svg": 1032,
	"./single-assets/PAUTO.png": 1033,
	"./single-assets/PBNB.png": 1034,
	"./single-assets/PEAR.svg": 1035,
	"./single-assets/PEFI.png": 1036,
	"./single-assets/PERA.png": 1037,
	"./single-assets/PETS.png": 1038,
	"./single-assets/PEX.png": 1039,
	"./single-assets/PHA.png": 1040,
	"./single-assets/PILLS.png": 1041,
	"./single-assets/PMP.svg": 1042,
	"./single-assets/PNG.png": 1043,
	"./single-assets/POLYGON.svg": 1044,
	"./single-assets/PORTO.png": 1045,
	"./single-assets/POTS.png": 1046,
	"./single-assets/PSP.png": 1047,
	"./single-assets/PTP.png": 1048,
	"./single-assets/PUP.png": 1049,
	"./single-assets/PolyDoge.png": 1050,
	"./single-assets/QBT.svg": 1051,
	"./single-assets/QI.png": 1052,
	"./single-assets/QUICK.png": 1053,
	"./single-assets/QUIDD.png": 1054,
	"./single-assets/RABBIT.svg": 1055,
	"./single-assets/RACA.svg": 1056,
	"./single-assets/RAMP.png": 1057,
	"./single-assets/RELAY.png": 1058,
	"./single-assets/REVV.svg": 1059,
	"./single-assets/RIB.png": 1060,
	"./single-assets/ROME.png": 1061,
	"./single-assets/ROSE.png": 1062,
	"./single-assets/ROUTE.png": 1063,
	"./single-assets/RPG.png": 1064,
	"./single-assets/SAGE.png": 1065,
	"./single-assets/SAND.png": 1066,
	"./single-assets/SANTOS.png": 1067,
	"./single-assets/SBDO.png": 1068,
	"./single-assets/SCREAM.png": 1069,
	"./single-assets/SFP.png": 1070,
	"./single-assets/SFUND.png": 1071,
	"./single-assets/SHADE.png": 1072,
	"./single-assets/SHIB.png": 1073,
	"./single-assets/SHIBX.png": 1074,
	"./single-assets/SHRAP.png": 1075,
	"./single-assets/SING.png": 1076,
	"./single-assets/SISTA.svg": 1077,
	"./single-assets/SKILL.svg": 1078,
	"./single-assets/SKY.svg": 1079,
	"./single-assets/SMART.png": 1080,
	"./single-assets/SNX.png": 1081,
	"./single-assets/SOAK.png": 1082,
	"./single-assets/SOL.png": 1083,
	"./single-assets/SOLACE.png": 1084,
	"./single-assets/SOLAR.png": 1085,
	"./single-assets/SOLID.svg": 1086,
	"./single-assets/SPADE.png": 1087,
	"./single-assets/SPELL.png": 1088,
	"./single-assets/SPIRIT.png": 1089,
	"./single-assets/SPS.svg": 1090,
	"./single-assets/STARS.svg": 1091,
	"./single-assets/START.png": 1092,
	"./single-assets/STATIC.png": 1093,
	"./single-assets/STEAK.png": 1094,
	"./single-assets/STEEL.png": 1095,
	"./single-assets/STELLA.png": 1096,
	"./single-assets/STNEAR.png": 1097,
	"./single-assets/SUMMIT.png": 1098,
	"./single-assets/SUSHI.png": 1099,
	"./single-assets/SUSHIe.png": 1100,
	"./single-assets/SWAMP.svg": 1101,
	"./single-assets/SX.png": 1102,
	"./single-assets/SXP.svg": 1103,
	"./single-assets/SYN.svg": 1104,
	"./single-assets/TAPE.svg": 1105,
	"./single-assets/TEL.png": 1106,
	"./single-assets/TENFI.png": 1107,
	"./single-assets/TETHYS.svg": 1108,
	"./single-assets/TETU.svg": 1109,
	"./single-assets/THG.png": 1110,
	"./single-assets/TIME.png": 1111,
	"./single-assets/TITAN.svg": 1112,
	"./single-assets/TLOS.svg": 1113,
	"./single-assets/TOMB.png": 1114,
	"./single-assets/TONIC.svg": 1115,
	"./single-assets/TOR.svg": 1116,
	"./single-assets/TREEB.png": 1117,
	"./single-assets/TRI.svg": 1118,
	"./single-assets/TRX.png": 1119,
	"./single-assets/TSHARE.svg": 1120,
	"./single-assets/TUS.png": 1121,
	"./single-assets/TUSD.png": 1122,
	"./single-assets/TYPH.png": 1123,
	"./single-assets/UFT.png": 1124,
	"./single-assets/UNI.png": 1125,
	"./single-assets/UNIe.png": 1126,
	"./single-assets/USDB.png": 1127,
	"./single-assets/USDC.svg": 1128,
	"./single-assets/USDCe.svg": 1129,
	"./single-assets/USDCm.svg": 1130,
	"./single-assets/USDCs.svg": 1131,
	"./single-assets/USDD.png": 1132,
	"./single-assets/USDL.svg": 1133,
	"./single-assets/USDO.png": 1134,
	"./single-assets/USDT.svg": 1135,
	"./single-assets/USDTe.svg": 1136,
	"./single-assets/UST.png": 1137,
	"./single-assets/UST_Rose.png": 1138,
	"./single-assets/USTaxl.png": 1139,
	"./single-assets/USTw.png": 1140,
	"./single-assets/VALAS.svg": 1141,
	"./single-assets/VERSA.svg": 1142,
	"./single-assets/VOLT.png": 1143,
	"./single-assets/VS.svg": 1144,
	"./single-assets/VTX.png": 1145,
	"./single-assets/VVS.svg": 1146,
	"./single-assets/WAN.svg": 1147,
	"./single-assets/WATCH.png": 1148,
	"./single-assets/WAULTx.svg": 1149,
	"./single-assets/WBNB.svg": 1150,
	"./single-assets/WBTC.svg": 1151,
	"./single-assets/WBTCe.svg": 1152,
	"./single-assets/WBTCeth.svg": 1153,
	"./single-assets/WCRO.svg": 1154,
	"./single-assets/WETH.svg": 1155,
	"./single-assets/WETHe.svg": 1156,
	"./single-assets/WEX.svg": 1157,
	"./single-assets/WEXpoly.png": 1158,
	"./single-assets/WIGO.svg": 1159,
	"./single-assets/WIN.png": 1160,
	"./single-assets/WINE.png": 1161,
	"./single-assets/WMATIC.svg": 1162,
	"./single-assets/WMATIC_DFYN.svg": 1163,
	"./single-assets/WMOVR_SUSHI.png": 1164,
	"./single-assets/WOO.svg": 1165,
	"./single-assets/WOOFY.png": 1166,
	"./single-assets/WOOP.png": 1167,
	"./single-assets/WSG.svg": 1168,
	"./single-assets/WSTA.png": 1169,
	"./single-assets/WUSD.svg": 1170,
	"./single-assets/XAVA.png": 1171,
	"./single-assets/XCV.svg": 1172,
	"./single-assets/XRP.svg": 1173,
	"./single-assets/XTZ.png": 1174,
	"./single-assets/XVS.png": 1175,
	"./single-assets/XWG.png": 1176,
	"./single-assets/YAMP.svg": 1177,
	"./single-assets/YEL.svg": 1178,
	"./single-assets/YELD.png": 1179,
	"./single-assets/YETI.png": 1180,
	"./single-assets/YFI.png": 1181,
	"./single-assets/YFIe.png": 1182,
	"./single-assets/YGG.png": 1183,
	"./single-assets/YOSHI.png": 1184,
	"./single-assets/YUSD.png": 1185,
	"./single-assets/YUZU.png": 1186,
	"./single-assets/ZBTC.svg": 1187,
	"./single-assets/ZETH.svg": 1188,
	"./single-assets/ZOO.png": 1189,
	"./single-assets/aBNBc.png": 1190,
	"./single-assets/aQI.png": 1191,
	"./single-assets/aROME.png": 1192,
	"./single-assets/aUSDO.svg": 1193,
	"./single-assets/aWOOL.png": 1194,
	"./single-assets/agEUR.png": 1195,
	"./single-assets/anyMTLX.png": 1196,
	"./single-assets/asUSDC.png": 1197,
	"./single-assets/axlATOM.png": 1198,
	"./single-assets/bQI.png": 1199,
	"./single-assets/bZoo.png": 1200,
	"./single-assets/beFTM.svg": 1201,
	"./single-assets/beJOE.png": 1202,
	"./single-assets/beQI.png": 1203,
	"./single-assets/binSPIRIT.svg": 1204,
	"./single-assets/bsc/BSHARE.png": 2515,
	"./single-assets/bscBUSD.svg": 1205,
	"./single-assets/cEUR.png": 1206,
	"./single-assets/cUSD.png": 1207,
	"./single-assets/cakeHARD.png": 1208,
	"./single-assets/cakeROOBEE.png": 1209,
	"./single-assets/cakeSTAX.png": 1210,
	"./single-assets/cakeTWT.png": 1211,
	"./single-assets/cakebROOBEE.png": 1212,
	"./single-assets/ceUSDC.svg": 1213,
	"./single-assets/cxADA.png": 1214,
	"./single-assets/cxBTC.png": 1215,
	"./single-assets/cxDOGE.png": 1216,
	"./single-assets/cxETH.png": 1217,
	"./single-assets/evoBTC.svg": 1218,
	"./single-assets/evoETH.svg": 1219,
	"./single-assets/evoUSDC.svg": 1220,
	"./single-assets/evoUSDT.svg": 1221,
	"./single-assets/fUSD.png": 1222,
	"./single-assets/fUSDT.png": 1223,
	"./single-assets/fWINGS.svg": 1224,
	"./single-assets/gOHM.jpg": 2516,
	"./single-assets/gOHM.png": 1225,
	"./single-assets/ibBTC.svg": 1226,
	"./single-assets/ironICE.svg": 1227,
	"./single-assets/jCHF.png": 1228,
	"./single-assets/jEUR.png": 1229,
	"./single-assets/jGBP.png": 1230,
	"./single-assets/jJPY.png": 1231,
	"./single-assets/jNZD.svg": 1232,
	"./single-assets/mUSDC.svg": 1233,
	"./single-assets/mUSDT.svg": 1234,
	"./single-assets/miMatic.png": 1235,
	"./single-assets/newQUICK.svg": 1236,
	"./single-assets/pAVAX.svg": 1237,
	"./single-assets/pBNB.svg": 1238,
	"./single-assets/pBREW.png": 1239,
	"./single-assets/pFTM.svg": 1240,
	"./single-assets/pMATIC.svg": 1241,
	"./single-assets/pOPEN.png": 1242,
	"./single-assets/pWINGS.png": 1243,
	"./single-assets/polyBUNNY.png": 1244,
	"./single-assets/polyWISE.png": 1245,
	"./single-assets/rUSD.svg": 1246,
	"./single-assets/renBTC.png": 1247,
	"./single-assets/renBTC.svg": 1248,
	"./single-assets/renDGB.svg": 1249,
	"./single-assets/renDOGE.png": 1250,
	"./single-assets/sALPACA.svg": 1251,
	"./single-assets/sAVAX.png": 1252,
	"./single-assets/sFTMx.png": 1253,
	"./single-assets/sSPELL.png": 1254,
	"./single-assets/stKSM.png": 1255,
	"./single-assets/stMATIC.png": 1256,
	"./single-assets/wMEMO.png": 1257,
	"./single-assets/wsHEC.png": 1258,
	"./single-assets/wsSPA.png": 1259,
	"./single-assets/xBOO.png": 1260,
	"./single-assets/xMARK.png": 1261,
	"./single-assets/xSCREAM.png": 1262,
	"./single-assets/xTRI.svg": 1263,
	"./single-assets/xVOLT.svg": 1264,
	"./single-assets/xYELD.svg": 1265,
	"./single-assets/xcDOT.png": 1266,
	"./single-assets/xcKSM.png": 1267,
	"./single-assets/xcRMRK.png": 1268,
	"./stake/2omb/bg.png": 2517,
	"./stake/2omb/logo.png": 2518,
	"./stake/annex/bg.png": 2519,
	"./stake/annex/logo.png": 2520,
	"./stake/apeswap/background.png": 2521,
	"./stake/apeswap/logo.png": 2522,
	"./stake/apyswap/background.png": 2523,
	"./stake/apyswap/logo.png": 2524,
	"./stake/astronaut/background.png": 2525,
	"./stake/astronaut/logo.png": 2526,
	"./stake/babyswap/bg.png": 2527,
	"./stake/babyswap/logo.png": 2528,
	"./stake/based/bg.png": 2529,
	"./stake/based/logo.png": 2530,
	"./stake/beefy/background.png": 2531,
	"./stake/beefy/beefyfinance.png": 2532,
	"./stake/beefy/beefyfinance_night.png": 2533,
	"./stake/betu/bg.png": 2534,
	"./stake/betu/logo.png": 2535,
	"./stake/billionhappiness/background.png": 2536,
	"./stake/billionhappiness/logo.png": 2537,
	"./stake/bingo/background.png": 2538,
	"./stake/bingo/logo.png": 2539,
	"./stake/bishares/bg.png": 2540,
	"./stake/bishares/logo.png": 2541,
	"./stake/bitcrush/bg.png": 2542,
	"./stake/bitcrush/logo.png": 2543,
	"./stake/biticity/background.png": 2544,
	"./stake/biticity/logo.png": 2545,
	"./stake/blockmine/bg.png": 2546,
	"./stake/blockmine/logo.png": 2547,
	"./stake/boneswap/background.png": 2548,
	"./stake/boneswap/logo.png": 2549,
	"./stake/boost.svg": 334,
	"./stake/cafeswap/background.png": 2550,
	"./stake/cafeswap/bg.png": 2551,
	"./stake/cafeswap/brew.png": 2552,
	"./stake/cafeswap/cafeswap.png": 2553,
	"./stake/cafeswap/logo.png": 2554,
	"./stake/ceek/bg.png": 2555,
	"./stake/ceek/logo.png": 2556,
	"./stake/charge/bg.png": 2557,
	"./stake/charge/logo.png": 2558,
	"./stake/crowfinance/background.png": 2559,
	"./stake/crowfinance/crow.png": 2560,
	"./stake/crowfinance/crowfinance.png": 2561,
	"./stake/czodiac/bg.png": 2562,
	"./stake/czodiac/logo.png": 2563,
	"./stake/dark/bg.png": 2564,
	"./stake/dark/logo.png": 2565,
	"./stake/dep/bg.png": 2566,
	"./stake/dep/logo.png": 2567,
	"./stake/dibs/bg.png": 2568,
	"./stake/dibs/logo.png": 2569,
	"./stake/dopple/background.png": 2570,
	"./stake/dopple/logo.png": 2571,
	"./stake/dumpling/background.png": 2572,
	"./stake/dumpling/logo.png": 2573,
	"./stake/elk/bg.png": 2574,
	"./stake/elk/logo.png": 2575,
	"./stake/elon/bg.png": 2576,
	"./stake/elon/logo.png": 2577,
	"./stake/esterfinance/background.png": 2578,
	"./stake/esterfinance/logo.png": 2579,
	"./stake/f1.png": 1270,
	"./stake/fanatics/logo.png": 2580,
	"./stake/farmhero/bg.png": 2581,
	"./stake/farmhero/logo.png": 2582,
	"./stake/fire.png": 466,
	"./stake/fruit/background.png": 2583,
	"./stake/fruit/logo.png": 2584,
	"./stake/fuse/bg.png": 2585,
	"./stake/fuse/logo.png": 2586,
	"./stake/gamexchange/bg.png": 2587,
	"./stake/gamexchange/logo.png": 2588,
	"./stake/garuda/logo.png": 2589,
	"./stake/grandbanks/background.png": 2590,
	"./stake/grandbanks/logo.png": 2591,
	"./stake/grape/bg.png": 2592,
	"./stake/grape/logo.png": 2593,
	"./stake/honey/bg.png": 2594,
	"./stake/honey/logo.png": 2595,
	"./stake/huckleberry/bg.png": 2596,
	"./stake/huckleberry/logo.png": 2597,
	"./stake/icarus/background.png": 2598,
	"./stake/icarus/logo.png": 2599,
	"./stake/ironfinance/background.png": 2600,
	"./stake/ironfinance/logo.png": 2601,
	"./stake/jarvis/bg.png": 2602,
	"./stake/jarvis/logo.png": 2603,
	"./stake/jetswap/background.png": 2604,
	"./stake/jetswap/logo.png": 2605,
	"./stake/krown/background.png": 2606,
	"./stake/krown/logo.png": 2607,
	"./stake/landshare/bg.png": 2608,
	"./stake/landshare/logo.png": 2609,
	"./stake/launchpool.png": 1271,
	"./stake/liquidus/bg.png": 2610,
	"./stake/liquidus/logo.png": 2611,
	"./stake/longdrink/bg.png": 2612,
	"./stake/longdrink/logo.png": 2613,
	"./stake/mash/background.png": 2614,
	"./stake/mash/logo.png": 2615,
	"./stake/memefarm/ape.png": 2616,
	"./stake/memefarm/background.png": 2617,
	"./stake/memefarm/logo.png": 2618,
	"./stake/merlin/background.png": 2619,
	"./stake/merlin/logo.png": 2620,
	"./stake/mogul/bg.png": 2621,
	"./stake/mogul/logo.png": 2622,
	"./stake/moonpot/bg.png": 2623,
	"./stake/moonpot/logo.png": 2624,
	"./stake/nfty/bg.png": 2625,
	"./stake/nfty/logo.png": 2626,
	"./stake/oasis/bg.png": 2627,
	"./stake/oasis/logo.png": 2628,
	"./stake/omnifarm/bg.png": 2629,
	"./stake/omnifarm/logo.png": 2630,
	"./stake/pacoca/bg.png": 2631,
	"./stake/pacoca/logo.png": 2632,
	"./stake/panther/background.png": 2633,
	"./stake/panther/logo.png": 2634,
	"./stake/pearzap/bg.png": 2635,
	"./stake/pearzap/logo.png": 2636,
	"./stake/pera/bg.png": 2637,
	"./stake/pera/logo.png": 2638,
	"./stake/polyalpha/bg.png": 2639,
	"./stake/polyalpha/logo.png": 2640,
	"./stake/polycracker/bg.png": 2641,
	"./stake/polycracker/logo.png": 2642,
	"./stake/polyfarm/bg.png": 2643,
	"./stake/polyfarm/logo.png": 2644,
	"./stake/polygon/background.png": 2645,
	"./stake/polygon/logo.png": 2646,
	"./stake/polypup/background.png": 2647,
	"./stake/polypup/logo.png": 2648,
	"./stake/polysage/bg.png": 2649,
	"./stake/polysage/logo.png": 2650,
	"./stake/polywise/bg.png": 2651,
	"./stake/polywise/logo.png": 2652,
	"./stake/polyyeld/background.png": 2653,
	"./stake/polyyeld/logo.png": 2654,
	"./stake/qidao/background.png": 2655,
	"./stake/qidao/logo.png": 2656,
	"./stake/ramenswap/background.png": 2657,
	"./stake/ramenswap/ramen.png": 2658,
	"./stake/ramenswap/ramenswap.png": 2659,
	"./stake/relay/bg.png": 2660,
	"./stake/relay/logo.png": 2661,
	"./stake/ripae/bg.png": 2662,
	"./stake/ripae/logo.png": 2663,
	"./stake/safefarm/background.png": 2664,
	"./stake/safefarm/logo.png": 2665,
	"./stake/saltswap/background.png": 2666,
	"./stake/saltswap/salt.png": 2667,
	"./stake/saltswap/saltswap.png": 2668,
	"./stake/sandman/bg.png": 2669,
	"./stake/sandman/logo.png": 2670,
	"./stake/satis/background.png": 2671,
	"./stake/satis/logo.png": 2672,
	"./stake/scream/bg.png": 2673,
	"./stake/scream/logo.png": 2674,
	"./stake/singular/bg.png": 2675,
	"./stake/singular/logo.png": 2676,
	"./stake/slimefinance/background.png": 2677,
	"./stake/slimefinance/logo.png": 2678,
	"./stake/slimefinance/slime.png": 2679,
	"./stake/soup/background.png": 2680,
	"./stake/soup/logo.png": 2681,
	"./stake/space/background.png": 2682,
	"./stake/space/logo.png": 2683,
	"./stake/spirit/bg.png": 2684,
	"./stake/spirit/logo.png": 2685,
	"./stake/squirrel/background.png": 2686,
	"./stake/squirrel/logo.png": 2687,
	"./stake/squirrel/nuts.png": 2688,
	"./stake/stellaswap/bg.png": 2689,
	"./stake/stellaswap/logo.png": 2690,
	"./stake/swirl/background.png": 2691,
	"./stake/swirl/logo.png": 2692,
	"./stake/tanks/bg.png": 2693,
	"./stake/tanks/logo.png": 2694,
	"./stake/tenfi/background.png": 2695,
	"./stake/tenfi/logo.png": 2696,
	"./stake/ternoa/bg.png": 2697,
	"./stake/ternoa/logo.png": 2698,
	"./stake/tetu/bg.png": 2699,
	"./stake/tetu/logo.png": 2700,
	"./stake/thunder/background.png": 2701,
	"./stake/thunder/logo.png": 2702,
	"./stake/thypoon/background.png": 2703,
	"./stake/thypoon/logo.png": 2704,
	"./stake/tombfinance/background.png": 2705,
	"./stake/tombfinance/logo.png": 2706,
	"./stake/tosdis/bg.png": 2707,
	"./stake/tosdis/logo.png": 2708,
	"./stake/viralata/bg.png": 2709,
	"./stake/viralata/logo.png": 2710,
	"./stake/wigoswap/bg.png": 2711,
	"./stake/wigoswap/logo.png": 2712,
	"./stake/wolfden/bg.png": 2713,
	"./stake/wolfden/logo.png": 2714,
	"./stake/wsg/bg.png": 2715,
	"./stake/wsg/logo.png": 2716,
	"./stake/xbtc/background.png": 2717,
	"./stake/xbtc/logo.png": 2718,
	"./stake/xyeld/bg.png": 2719,
	"./stake/xyeld/logo.png": 2720,
	"./stake/xyeld/xyeld-matic.svg": 2721,
	"./stake/yel/bg.png": 2722,
	"./stake/yel/logo.png": 2723,
	"./stake/yieldbay/background.png": 2724,
	"./stake/yieldbay/logo.png": 2725,
	"./stake/yieldwatch/bg.png": 2726,
	"./stake/yieldwatch/logo.png": 2727,
	"./stake/zcore/background.png": 2728,
	"./stake/zcore/logo.png": 2729,
	"./uncategorized/3CRV.png": 2730,
	"./uncategorized/ATRICRYPTO.png": 2731,
	"./uncategorized/BADGER-BTCB.svg": 2732,
	"./uncategorized/BAT-BAKE.svg": 2733,
	"./uncategorized/BDIGG-BTCB.svg": 2734,
	"./uncategorized/BELT-VENUSBLP.png": 2735,
	"./uncategorized/BETH-ETH.svg": 2736,
	"./uncategorized/COMP-ETH.svg": 2737,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 2738,
	"./uncategorized/DOPPLE-DOP-LP.svg": 2739,
	"./uncategorized/DOPPLE-UST-LP.png": 2740,
	"./uncategorized/ETH-USDT.png": 2741,
	"./uncategorized/IRON-3USD.png": 2742,
	"./uncategorized/IRON3USD.png": 2743,
	"./uncategorized/MAI-av3CRV.svg": 2744,
	"./uncategorized/MIM2CRV.svg": 2745,
	"./uncategorized/PNT-PBTC.svg": 2746,
	"./uncategorized/SUSHI-ETH.svg": 2747,
	"./uncategorized/TBTC-BTCB.svg": 2748,
	"./uncategorized/THUGS-NAR.png": 2749,
	"./uncategorized/bTRI-CRED.png": 2750,
	"./uncategorized/crv2pool.png": 2751,
	"./uncategorized/eps3.png": 2752,
	"./uncategorized/epsBNB.png": 2753,
	"./uncategorized/epsFUSDT.png": 2754,
	"./uncategorized/epsPBTC.png": 2755,
	"./uncategorized/epsRENBTC.png": 2756,
	"./uncategorized/epsUSDN.png": 2757,
	"./uncategorized/frax-3pool.png": 2758,
	"./uncategorized/nUSD-LP.png": 2759,
	"./uncategorized/solar-3pool.png": 2760,
	"./usdt-pairs/ALPACA-USDT.png": 2761,
	"./usdt-pairs/BIFI-USDT.png": 2762,
	"./usdt-pairs/BNB-USDT.png": 2763,
	"./usdt-pairs/BTCB-USDT.svg": 2764,
	"./usdt-pairs/ETH-USDT.svg": 2765,
	"./usdt-pairs/FIL-USDT.png": 2766,
	"./usdt-pairs/LHB-USDT.png": 2767,
	"./usdt-pairs/LYD-USDT.png": 2768,
	"./usdt-pairs/MATIC-USDT.png": 2769,
	"./usdt-pairs/SHIB-USDT.png": 2770,
	"./usdt-pairs/TUSD-USDT.png": 2771,
	"./usdt-pairs/WEX-USDT.png": 2772,
	"./ust-pairs/MAMZN-UST.svg": 2773,
	"./ust-pairs/MCOIN-UST.svg": 2774,
	"./ust-pairs/MGOOGL-UST.svg": 2775,
	"./ust-pairs/MIR-UST.svg": 2776,
	"./ust-pairs/MNFLX-UST.svg": 2777,
	"./ust-pairs/MTSLA-UST.svg": 2778,
	"./wallets/binance-wallet.png": 713,
	"./wallets/bitkeep-wallet.png": 172,
	"./wallets/clover.png": 286,
	"./wallets/coinbase.png": 233,
	"./wallets/crypto.png": 717,
	"./wallets/fusecash.png": 718,
	"./wallets/math-wallet.svg": 464,
	"./wallets/metamask.png": 2779,
	"./wallets/metamask.svg": 2780,
	"./wallets/safepal-wallet.svg": 715,
	"./wallets/trust-wallet.svg": 714,
	"./wallets/valora.png": 716,
	"./wallets/wallet-connect.svg": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;